import React, {useEffect, useState} from 'react'
import useApiRequest from './useApiRequest'
import { domain } from './Domain'
import { motion, AnimatePresence } from 'framer-motion'
import "../css/Activation.css"
import { useNavigate } from 'react-router-dom'

const Activation = () => {
  const navigate = useNavigate()
  const { getRequest, response } = useApiRequest()
  const [success, setSuccess] = useState(false)
  const check = async(token) => {
    const response = await getRequest(`${domain}/accounts/activation?token=${token}`)
    if(response['message'] === "Acount Activation Successfull!"){
      setSuccess(true)
      setTimeout(()=>{
        navigate("/login")
      },3000)
    }
  }
  useEffect(()=>{
    const queryParams = new URLSearchParams(window.location.search);
    const tokenParam = queryParams.get('token');
    check(tokenParam)
  },[])
  return (
    <div className='activation'>
      <div className='inner'>
        <h1>Your Account is getting Activated <br />Please Wait</h1>
        <div className="lds-dual-ring"></div>
        <AnimatePresence>
          {success && 
            <motion.p initial={{scale: 0, opacity: 0}} animate={{scale:1, opacity: 1}} exit={{scale: 0, opacity: 0}} key={success} className='text-primary fw-bold text-center mt-4'>Account activation successfull<br />redirecting in 3 seconds ....</motion.p>
          }
        </AnimatePresence>
      </div>
    </div>
  )
}

export default Activation